import React from "react";

const TagHead = ({ title }) => {
  return (
    <div className="tag_head m-auto">
      <h2>{title}</h2>
    </div>
  );
};

export default TagHead;
